/**
 * Query Client Provider
 *
 * TanStack Query configuration for MaldevtaHub.
 */

import { QueryClient, QueryClientProvider as TanStackQueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
      // Cache is garbage collected after 10 minutes
      gcTime: 10 * 60 * 1000,

      // Don't refetch on window focus (reduces API calls)
      refetchOnWindowFocus: false,

      // Refetch on reconnect
      refetchOnReconnect: true,

      // Retry strategy
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors (except 429)
        if (error?.status >= 400 && error?.status < 500 && error?.status !== 429) {
          return false
        }
        // Retry up to 2 times for other errors
        return failureCount < 2
      },
    },

    mutations: {
      // Retry mutations once
      retry: 1,
    },
  },
})

export function QueryClientProvider({ children }: { children: React.ReactNode }) {
  return (
    <TanStackQueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </TanStackQueryClientProvider>
  )
}
